import { put, select, takeLatest } from 'redux-saga/effects'
import { FluidsConstants } from '../store/fluids.constants'
import { IFluidsState, ICustomFluidEntry } from '../store/fluids.types'
import { getFluidsSelector } from '../selectors'
import { getCustomFluidsOptionsSelector } from '../../options/selectors/getCustomFluidsOptions.selector'
import { makeActionCreator, randomNumber } from '../../../utilities'
import { ICustomFluidOption, ICustomFluidOptions } from '../../options/store/options.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

const setCustomFluids = makeActionCreator(FluidsConstants.SET_CUSTOM_FLUIDS, 'customFluids')

export function* setCustomFluidValue() {
  const fluidsState: IFluidsState = yield select(getFluidsSelector)
  const customFluidsOptions: ICustomFluidOptions = yield select(getCustomFluidsOptionsSelector)

  const { currentCustomFluidValue, currentCustomFluidOptionId, currentCustomFluidTransportPeriod } = fluidsState

  if (
    currentCustomFluidValue === undefined ||
    currentCustomFluidOptionId === undefined ||
    currentCustomFluidTransportPeriod === undefined
  ) {
    return
  }

  const option = customFluidsOptions.find((opt: ICustomFluidOption) => opt.id === currentCustomFluidOptionId)

  if (!option) {
    return
  }

  const existingIndex = fluidsState.customFluids.findIndex(
    (entry) => entry.id === currentCustomFluidOptionId && entry.transportPeriod === currentCustomFluidTransportPeriod
  )

  const updatedCustomFluids = [...fluidsState.customFluids]

  if (existingIndex >= 0) {
    updatedCustomFluids[existingIndex] = {
      ...updatedCustomFluids[existingIndex],
      value: currentCustomFluidValue || '',
    }
  } else {
    const newEntry: ICustomFluidEntry = {
      key: randomNumber().toString(),
      id: currentCustomFluidOptionId,
      name: option.name,
      unit: option.unit,
      intakeOutput: option.intakeOutput,
      transportPeriod: currentCustomFluidTransportPeriod,
      value: currentCustomFluidValue || '',
    }
    updatedCustomFluids.push(newEntry)
  }

  yield put(setCustomFluids(updatedCustomFluids))
}

export function* setCustomFluidValueSaga() {
  yield takeLatest(FluidsConstants.SET_CUSTOM_FLUID_VALUE, performWithMutexHOG, setCustomFluidValue)
}
